import AppStore from '../stores/AppStore'
import type { ComposerProfile } from '../stores/types'

type UseFormattedProfilesReturn = {
  formattedProfiles: ComposerProfile[]
}

export const useFormattedProfiles = (): UseFormattedProfilesReturn => {
  const profiles = AppStore.getProfiles()
  const formattedProfiles = profiles.map((profile: ComposerProfile) => {
    return {
      ...profile,
      service: {
        ...profile.service,
        name: profile.service.name,
      },
    }
  })

  return {
    formattedProfiles,
  }
}
